import React from "react";
import { Button, Card, CardContent, Typography } from "@material-ui/core";
import { t } from "adapters/i18n";

export function ForageCycleLoadError({ onRetry }: { onRetry: () => void }) {
  return (
    <Card className="forage-cycle-load-error" role="alert">
      <CardContent className="forage-cycle-load-error__content">
        <Typography color="error" className="forage-cycle-load-error__message">
          {t("forageCycle:cycle-management-load-error")}
        </Typography>
        <Button color="primary" onClick={onRetry}>
          {t("forageCycle:cycle-retry-load")}
        </Button>
      </CardContent>
    </Card>
  );
}

export function ForageCycleEmptyState() {
  return (
    <Card
      className="forage-cycle-empty-state"
      data-testid="cycle-list-empty"
      elevation={0}
    >
      <Typography className="forage-cycle-empty-state__title">
        {t("forageCycle:cycle-management-empty")}
      </Typography>
      <Typography className="forage-cycle-empty-state__description">
        {t("forageCycle:cycle-management-empty-description")}
      </Typography>
    </Card>
  );
}
